import React, { Component } from 'react';
import GlowingEffect from '../../glowing-effect/glowing-effect';

class GeckoCardWrapper extends Component {

    render() {
		return (
            <div className="w-full rounded-2xl border-[0.5px] border-slate-200 bg-clip-padding p-1.5 shadow-[0_1px_2px_0_rgb(30_58_138/0.05)] backdrop-blur-sm backdrop-saturate-[2]">
                <div className="relative w-full bg-white shadow-lg rounded-lg border border-slate-200">
                    <GlowingEffect
                        spread={40}
                        glow={true}
                        disabled={false}
                        proximity={64}
                        inactiveZone={0.01}
                    />
                    <div className="relative">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}


export default GeckoCardWrapper;